import { render, staticRenderFns } from "./AdminWebsiteText.vue?vue&type=template&id=666efc40&"
import script from "./AdminWebsiteText.vue?vue&type=script&lang=js&"
export * from "./AdminWebsiteText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports